import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

const swalOptions = {
  confirmButtonColor: '#3DBFA0',
  cancelButtonColor: '#1A2E4A',
};

const showAlert = Swal.mixin(swalOptions);

export async function showConfirm(
  title: string,
  text: string,
  confirmText: string,
  cancelText: string,
): Promise<boolean> {
  const result = await showAlert.fire({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    confirmButtonColor: swalOptions.confirmButtonColor,
    cancelButtonColor: swalOptions.cancelButtonColor,
  });
  return result.isConfirmed;
}

export function showSuccess(title: string, text?: string): void {
  showAlert.fire({
    title,
    text,
    icon: 'success',
    confirmButtonText: 'OK',
    confirmButtonColor: swalOptions.confirmButtonColor,
  });
}

export function showError(title: string, text?: string): void {
  showAlert.fire({
    title,
    text,
    icon: 'error',
    confirmButtonText: 'OK',
    confirmButtonColor: swalOptions.confirmButtonColor,
  });
}

export function useSwalAlerts() {
  const { t } = useTranslation('home');

  const showAlert2 = Swal.mixin(swalOptions);

  const showComingSoon = () => {
    showAlert2.fire({
      title: t('admin_coming_soon'),
      text: t('admin_requires_backend'),
      icon: 'info',
      confirmButtonText: t('admin_ok'),
    });
  };

  const showQuoteRequest = () => {
    showAlert2.fire({
      title: t('contact_title'),
      html: `<p style="margin-bottom: 12px;">${t('contact_cta_desc')}</p>`,
      icon: 'info',
      confirmButtonText: t('admin_close'),
    });
  };

  return { showAlert: showAlert2, showComingSoon, showQuoteRequest };
}